import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  axios,
  dataFetcher,
  endpoints,
  baseUrl,
  cloudBaseUrl,
  getToken,
} from 'Api';
import { Skeleton } from '@mui/material';
import { AppContext } from 'Context';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'Components';
import CustomButton from 'Components/button/CustomButton';
import { pollSelectedPhotos } from './pollSelectedPhotos'; // ✅ works with named export
import VideoImg from '../../../../Assets/video.png';
import { StoragePage } from '../components/page';
import { videoArray } from './DataArray';
import { photoArray } from './PhotoArray';
import Publish from '../PublishUi/Publish';
import Sort from '../../../../Assets/sort.png';
import styles from './index.module.css';
import Shimmer from '../Shimmer';
import GooglePhotosConnectButton from './GooglePhotosConnectButton';
import GooglePublish from '../PublishUi/GooglePublish';

export const GooglePhotosCloud = () => {
  const {
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setOpenX,
    cloudToken,
  } = useContext(AppContext);
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const location = useLocation();
  const [data, setData] = useState([]); // default to empty array
  const [selectedTag, setSelectedTag] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef(null);
  const allTypes = storageSelectedItems.map((item) => item?.type);
  const isOnlyPhotos = allTypes.every((type) => type === 'PHOTO');
  const isOnlyVideos = allTypes.every((type) => type === 'VIDEO');
  const shouldRender = isOnlyPhotos || isOnlyVideos;
  const isFilterActive = selectedTag?.length < 2; // if one type is unselected, filtering is active
  const filteredData = isFilterActive
    ? data?.filter((item) => selectedTag?.includes(item?.type))
    : data; // show all when both PHOTO and VIDEO are selected

  const bottomRef = useRef();

  const [thumbnailSelected, setThumbnailSelected] = useState();
  const [addToProjector, setAddToProjector] = useState(false);
  const [detailsData, setDetailsData] = useState({
    title: storageSelectedItems[0]?.mediaFile?.filename,
    description: '',
    visibility: 2,
    group: [], // ✅ Must be an array!
  });
  useEffect(() => {
    if (storageSelectedItems.length === 1 && isOnlyVideos) {
      setDetailsData((prev) => ({
        ...prev,
        title: storageSelectedItems[0]?.mediaFile?.filename || '',
      }));
    }
  }, [storageSelectedItems]);
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / 1024 ** i).toFixed(2)} ${sizes[i]}`;
  };
  const groupByDate = (files) => {
    if (!Array.isArray(files)) return {};
    return files.reduce((acc, file) => {
      const dateObj = new Date(file.uploaded_at);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(file);
      return acc;
    }, {});
  };
  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const groupedFiles = groupByDate(data?.results);
  const handleSelect = (item) => {
    console.log('item', item);
    const isAlreadySelected = storageSelectedItems.some(
      (selected) => selected.id === item.id
    ); // assuming `id` is unique
    if (isAlreadySelected) {
      setStorageSelectedItems(
        storageSelectedItems.filter((selected) => selected.id !== item.id)
      );
    } else {
      setStorageSelectedItems([...storageSelectedItems, item]);
    }
  };

  useEffect(() => {
    // Clear selected items when route changes
    setStorageSelectedItems([]);
  }, [location.pathname]); // triggered every time the path changes

  const addAlbum = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/cloud/addAlbum`,
        {
          token: getToken(),
          title: detailsData?.title,
          description: detailsData.description,
          // group: groupId.toString(),
          visibility: detailsData?.visibility.toString(),
          icon: storageSelectedItems[0]?.pre_url,
          photos: storageSelectedItems?.map((obj) => obj?.pre_url),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Album added successfully:', response.data);
      setStorageSelectedItems([]);
      return response.data;
    } catch (error) {
      console.error(
        'Error adding album:',
        error.response?.data || error.message
      );
      throw error;
    }
  };
  const publishHandler = () => {
    if (isOnlyVideos && storageSelectedItems?.length > 1) {
      setOpenX(true);
    }
    if (addToProjector) {
      // addAlbum();
      setAddToProjector(false);
    } else {
      setAddToProjector(true);
    }
  };
  const clientId = '526946985013-7ol8pss03r4cd6dqbijso7a4pfrgnhsi.apps.googleusercontent.com';
  const clientSecret = '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';
  const redirectUri = 'http://localhost:3000/storage/google-photos';
  const scopes = [
    'https://www.googleapis.com/auth/photospicker.mediaitems.readonly',
  ];

  const handleGooglePhotosOAuth = () => {
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
      {
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: scopes.join(' '),
        access_type: 'offline',
        prompt: 'consent',
      }
    ).toString()}`;

    window.location.href = authUrl; // Redirects user to Google's OAuth screen
  };

  const handleTokenAndLaunchPicker = async (code) => {
    try {
      const tokenResponse = await fetch('https://oauth2.googleapis.com/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          code,
          client_id: clientId,
          client_secret: clientSecret,
          redirect_uri: redirectUri,
          grant_type: 'authorization_code',
        }),
      });

      const tokenData = await tokenResponse.json();
      if (!tokenData.access_token) {
        alert('Failed to get access token');
        return;
      }

      const accessToken = tokenData.access_token;

      const sessionResp = await fetch(
        'https://photospicker.googleapis.com/v1/sessions',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
          body: '{}',
        }
      );

      const sessionData = await sessionResp.json();

      if (sessionData?.pickerUri && sessionData?.id) {
        // Save accessToken & sessionId to use after redirect
        localStorage.setItem('google_photos_token', accessToken);
        localStorage.setItem('google_photos_session_id', sessionData.id);

        // Redirect to picker
        window.location.href = sessionData.pickerUri;
      } else {
        alert('Failed to launch photo picker.');
        console.error(sessionData);
      }
    } catch (error) {
      console.error('OAuth error:', error);
      alert('Something went wrong during authentication.');
    }
  };
  const shouldPoll = typeof window !== 'undefined'
    && localStorage.getItem('google_photos_token')
    && localStorage.getItem('google_photos_session_id');
  const accessToken = localStorage.getItem('google_photos_token');
  const sessionId = localStorage.getItem('google_photos_session_id');
  useEffect(() => {
    if (shouldPoll) {
      pollSelectedPhotos(
        sessionId,
        accessToken,
        setLoading,
        setData,
        setNextPageToken,
        setHasMore,
        nextPageToken
      );
    }
  }, [shouldPoll]);
  const [blobUrls, setBlobUrls] = useState([]);

  useEffect(() => {
    if (!data || !accessToken) return;

    const fetchAllImages = async () => {
      const urls = await Promise.all(
        data.map(async (item) => {
          if (item?.mediaFile?.mimeType?.startsWith('image/')) {
            try {
              const res = await axios.get(item.mediaFile.baseUrl, {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
                responseType: 'blob',
              });
              return URL.createObjectURL(res.data);
            } catch (err) {
              console.error('❌ Failed to fetch image blob', err);
              return null;
            }
          }
          return null;
        })
      );

      setBlobUrls(urls);
    };

    fetchAllImages();
  }, [data, accessToken]);

  console.log('datax', data, shouldRender);
  return (
    <StoragePage
      title="Google Photos"
      selected={selectedTag}
      setSelected={setSelectedTag}
      // addActionName={viewerText?.addViewer || 'Add viewer'}
      // addActionName={'Add viewer'}
      // link={Pathname.grantAccess}
    >
      <div className={styles.viewersDiv} style={{ height: '59vh' }}>
        {!storageSelectedItems?.length > 0 && (
          <GooglePhotosConnectButton
            handleGooglePhotosOAuth={handleGooglePhotosOAuth}
            handleTokenAndLaunchPicker={handleTokenAndLaunchPicker}
          />
        )}
        <div className={styles.aboveGrid}>
          <div className={styles.topix}>
            <div className={styles.GooglephotsContainer} ref={containerRef}>
              {loading ? (
                <div className={styles.shimmer}>
                  <Shimmer type="photos" />
                </div>
              ) : data?.length > 0 ? (
                filteredData?.map((item, index) => (
                  <div>
                    {item?.type === 'PHOTO' ? (
                      <div
                        className={styles.gridPhx}
                        key={index}
                        role="button"
                        tabIndex={0}
                        onClick={() => handleSelect(item)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            handleSelect(item);
                          }
                        }}
                      >
                        <Checkbox
                          checked={storageSelectedItems?.some(
                            (selected) => selected.id === item.id
                          )}
                          icon={<></>} // ✅ safely renders nothing
                          checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
                          sx={{
                            color: '#e6dfda',
                            '&.Mui-checked': {
                              color: '#e6dfda',
                            },
                          }}
                          style={{
                            position: 'absolute',
                            top: '40%',
                            left: '42%',
                            zIndex: 2,
                            borderRadius: 4,
                            padding: 0,
                            pointerEvents: 'none', // allow click-through
                          }}
                        />
                        <img
                          src={item.mediaFile.baseUrl}
                          alt={item?.mediaFile?.filename}
                          style={{ width: '100%' }}
                        />
                        {/* {item?.draft_id !== null && (
                      <img
                      className={styles.isStream}
                      src={Logo}
                      alt={item?.name}
                      />
                      )} */}
                      </div>
                    ) : (
                      <div
                        className={styles.gridPhxGoogle}
                        key={index}
                        role="button"
                        tabIndex={0}
                        onClick={() => handleSelect(item)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            handleSelect(item);
                          }
                        }}
                      >
                                                  <Checkbox
                          checked={storageSelectedItems?.some(
                            (selected) => selected.id === item.id
                          )}
                          icon={<></>} // ✅ safely renders nothing
                          checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
                          sx={{
                            color: '#e6dfda',
                            '&.Mui-checked': {
                              color: '#e6dfda',
                            },
                          }}
                          style={{
                            position: 'absolute',
                            top: '40%',
                            left: '42%',
                            zIndex: 2,
                            borderRadius: 4,
                            padding: 0,
                            pointerEvents: 'none', // allow click-through
                          }}
                                                  />
                        <div className={styles.thisIsRel}>
                          <img
                            src={item.mediaFile.baseUrl}
                            alt={item?.mediaFile?.filename}
                            style={{ width: '100%' }}
                          />
                          <img
                            className={styles.isVideo}
                            src={VideoImg}
                            alt={item?.name}
                          />
                        </div>
                      </div>
                    )}
                    <p className={styles.googleFileName}>
                      {item?.mediaFile?.filename}
                    </p>
                  </div>
                ))
              ) : (
                <div className={styles.noData}>No data found</div>
              )}
              {loadingNextPage
                && Array.from({ length: 16 }).map((_, index) => (
                  <div
                    className={styles.gridItemX}
                    key={index + data.results.length}
                  >
                    <Skeleton
                      variant="rectangular"
                      height={130}
                      width={100}
                      animation="wave"
                      sx={{
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {storageSelectedItems?.length > 0 && (
          <div className={styles.pendingViewersContainer}>
            <GooglePublish
              type={
                storageSelectedItems?.length > 0
                && storageSelectedItems[0]?.type === 'PHOTO'
                  ? 'photos'
                  : 'video'
              }
              addToProjector={addToProjector}
              setSelectedCheckedItems={setStorageSelectedItems}
              selectedCheckedItems={storageSelectedItems}
              formatFileSize={formatFileSize}
              handleDetailsChange={handleDetailsChange}
              detailsData={detailsData}
              setDetailsData={setDetailsData}
              thumbnailSelected={thumbnailSelected}
              setThumbnailSelected={setThumbnailSelected}
            />

            <div className={styles.buttonsfleximo}>
              <CustomButton border="red" name="Delete" />
              {shouldRender && (
                <CustomButton
                  disabled={storageSelectedItems?.length < 1}
                  onClick={publishHandler}
                  border="#5AA5EF"
                  name="Publish Album"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </StoragePage>
  );
};
